// extracted by mini-css-extract-plugin
export default {"container":"OverviewTab_container__j6TRz","newsColumn":"OverviewTab_newsColumn__BOIkW","grid":"OverviewTab_grid__pdZaY"};